<template>
  <v-card class="card" color="primary">
    <v-card-text>
      <v-container>
        <v-row>
          <v-col align="right">
            <TextButton @click="openRegistrarNuevaRemesa"> REGISTRAR REMESA </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="remesas" class="transparent" calculate-widths>
                  <template v-slot:[`item.fk_idLoc`]="{ item }">
                    {{ getNoLicencia(item.fk_idLoc) }}
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton variant="secondary" icon="mdi-pencil" @click="openEditarRemesa(item)" />
                          </span>
                        </template>
                        <span>Editar Remesa</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import TextButton from '@src/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import IconButton from '@src/components/base/IconButton.vue'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      loading: false,
      DIALOG_TYPES,
      selectedRemesa: null,
      headers: [
        { text: 'ID Loc', value: 'fk_idLoc' },
        { text: 'Fecha de Alta', value: 'fechaAlta' },
        { text: 'Fecha de Trámite', value: 'fechaTramite' },
        { text: 'Número de Oficio', value: 'numOficio' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
    }
  },

  computed: {
    ...mapGetters('remesas', {
      remesas: 'getRemesas',
    }),
    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('remesas', {
      fetchRemesas: 'fetchRemesas',
    }),
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    getNoLicencia(idLoc) {
      const loc = this.locs.find((l) => l.idLoc === idLoc)
      return loc?.noLicencia || '-'
    },
    openRegistrarNuevaRemesa() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_REMESA)
    },
    openEditarRemesa(remesa) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_REMESA,
        props: { remesaSeleccionada: remesa },
      })
    },
  },

  created() {
    this.fetchRemesas()
    this.fetchLocs()
  },
}
</script>
